import * as zod from 'zod';

export const DeviceKinds = [
  'WeldMachine',
  'MillerWeldMachine',
  'EsabWeldMachine',
] as const;

export const DeviceKindsEnum = zod.enum(DeviceKinds);
